import { cva } from 'class-variance-authority';

const chipStyles = cva(
  'flex items-center justify-center px-2 py-1 rounded-full text-xs text-center font-semibold min-w-[62px] h-6 leading-none text-text-primary',
  {
    variants: {
      variant: {
        single: 'bg-primary-300 text-text-primary',
        'item-set': 'bg-info-300 text-text-primary',
      },
    },
    defaultVariants: {
      variant: 'single',
    },
  },
);

export type QuestionTypeChipProps =
  | { type: 'single' }
  | { type: 'item-set'; questionSize?: number | null };

export default function QuestionTypeChip(props: Readonly<QuestionTypeChipProps>) {
  const { type } = props;

  const LABEL = {
    single: 'Single',
    'item-set':
      type === 'item-set' && props.questionSize ? `Item Set: ${props.questionSize}Q` : 'Item Set',
  };

  return <div className={chipStyles({ variant: type })}>{LABEL[type]}</div>;
}
